import Code from "app/models/code"
// import { HrCode } from "app/models/hrCode"
import { Action, Types } from "./codesByCategory.actions"

interface CategoryHrCodes {
  [key: string]: Code[]
}

export type CodesByCategoryState = {
  data: CategoryHrCodes
  errors: {}
  loading: boolean
}

const initialState: CodesByCategoryState = {
  data: {},
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): CodesByCategoryState => {
  switch (action.type) {
    case Types.GET_BY_CATEGORY:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_BY_CATEGORY_SUCCESS: {
      const { category, data } = action.payload
      return {
        ...state,
        data: { ...state.data, [category]: data },
        loading: false,
      }
    }

    case Types.GET_BY_CATEGORY_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
